export enum PATHS {
  HOME = '/',
  USER_AREA = '/user-area',
  USER_AREA_WALLET = '/user-area#my-wallet',
  USER_AREA_CASHBACK = '/user-area#my-cashback',
  USER_AREA_UPCOMING_BOOKING_ID = '/user-area/upcoming-booking/[id]',
  USER_AREA_BOOKING_HISTORY = '/user-area/view-history',
  USER_AREA_BOOKING_HISTORY_ID = '/user-area/view-history/[id]',
  USER_AREA_DELETE_ACCOUNT = '/user-area/delete-account',
  USER_AREA_TRANSACTIONS = '/user-area/transactions',
  USER_AREA_TRANSACTIONS_CASHBACK = '/user-area/transactions/cashback',
  FINDER = '/movie-finder',
  MOVIES_SLUG = '/movies/[slug]',
  CINEMAS = '/cinemas',
  CINEMA_SLUG = '/cinemas/[slug]',
  EXPERIENCES = '/experiences',
  EXPERIENCES_SLUG = '/experiences/[slug]',
  MOVIES_SLUG_BOOKING = '/movies/[slug]/booking',
  BOOKINGS_ID_CHECKOUT = '/bookings/[id]/checkout',
  BOOKINGS_ID_CANCEL_TICKET = '/bookings/[id]/cancel-ticket',
  BOOKINGS_ID_YOUR_TICKET = '/bookings/[id]/checkout/your-ticket',
  BOOKINGS_ID_CONFIRMING = '/bookings/[id]/checkout/confirming',
  OFFERS = '/offers',
  OFFERS_SLUG = '/offers/[slug]',
  OFFERS_SLUG_SHOWS = '/offers/[slug]/shows',
  MOVIES_SLUG_OFFERS = '/movies/[slug]/offers',
  UNDER_MAINTENANCE = '/under-maintenance',
  TERMS_AND_CONDITIONS = '/terms-and-conditions',
}

export const CHANGE_CITY_LOGIC_PATHS: PATHS[] = [
  PATHS.MOVIES_SLUG,
  PATHS.CINEMA_SLUG,
  PATHS.EXPERIENCES_SLUG,
  PATHS.MOVIES_SLUG_BOOKING,
  PATHS.BOOKINGS_ID_CHECKOUT,
  PATHS.OFFERS_SLUG,
  PATHS.OFFERS_SLUG_SHOWS,
  PATHS.MOVIES_SLUG_OFFERS,
  PATHS.FINDER,
];

export const OFFERS_LOGIC_PATHS: PATHS[] = [
  PATHS.OFFERS_SLUG,
  PATHS.OFFERS_SLUG_SHOWS,
  PATHS.MOVIES_SLUG_OFFERS,
];

export const BOOKING_LOGIC_PATHS: PATHS[] = [
  PATHS.MOVIES_SLUG,
  PATHS.MOVIES_SLUG_BOOKING,
  PATHS.BOOKINGS_ID_CHECKOUT,
  PATHS.BOOKINGS_ID_CONFIRMING,
];

export const AUTH_USER_LOGIC_PATHS: PATHS[] = [
  PATHS.USER_AREA,
  PATHS.USER_AREA_UPCOMING_BOOKING_ID,
  PATHS.USER_AREA_BOOKING_HISTORY,
  PATHS.USER_AREA_BOOKING_HISTORY_ID,
  PATHS.USER_AREA_DELETE_ACCOUNT,
  PATHS.USER_AREA_TRANSACTIONS,
  PATHS.BOOKINGS_ID_CANCEL_TICKET,
];
